import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "wrapper", "backdrop"]

  connect() {
    this.modalTarget.classList.add("show")
    this.modalTarget.style.display = "block"
    applyBrandStyles();
  }

  close(e) {
    e.preventDefault()
    e.stopPropagation()
    this.modalTarget.remove()
    this.backdropTarget.remove()
    this.wrapperTarget.parentElement.removeAttribute("src")
  }
}
